import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Provider, forwardRef } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { MessagingService } from './services/messaging.service';
import { environment } from '../environments/environment';
import { AsyncPipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ChartsModule } from 'ng2-charts';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components

import { AngularEditorModule } from '@kolkov/angular-editor';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { ApiInterceptor } from './common/service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { LoaderModule } from './shared/loader/loader.module';
import { ForgetPasswordComponent } from './views/login/forgetPassword.component';
import { ResetPasswordComponent } from './views/login/resetPassword.component';
import { SignUpComponent } from './views/login/signup.component';
import { AddSelfGuestComponent } from './views/resident/addSelfGuest.component';
import { AddSelfCheckInComponent } from './views/resident/addSelfCheckIn.component';
import { SelfCheckInFormComponent } from './views/SelfCheckIn/selfCheckInForm.component';
import { SuccessComponent } from './views/error/success.component';
import { ExpireComponent } from './views/error/expire.component';
import { vehicleModule } from './views/vehicleManagement/vehicle.module';
import {scrapAgentModule } from './views/ScrapAgentManagement/scrapAgent.module';

export const API_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useExisting: forwardRef(() => ApiInterceptor),
  multi: true
  };

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    ChartsModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    HttpClientModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    AngularEditorModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AutocompleteLibModule,
    LoaderModule,
    FormsModule,
    vehicleModule,
    scrapAgentModule,
    AngularFireModule.initializeApp(environment.firebase),
    ToastrModule.forRoot({
      timeOut: 4000,
      preventDuplicates: true,
    })
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    SuccessComponent,
    ExpireComponent,
    LoginComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    AddSelfGuestComponent,
    AddSelfCheckInComponent,
    SelfCheckInFormComponent,
    SignUpComponent
    ],
  providers: [
    ApiInterceptor,
    MessagingService,
    AsyncPipe,
    API_INTERCEPTOR_PROVIDER,
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
  }],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
